import { L10n } from '../L10n/L10n';
import { Module } from '../Module';

export interface ILocalizedPercentFilter {
  (value: number): string;
}

Module.instance().filter('localizedPercent', (): ILocalizedPercentFilter => {
  return L10n.localizedPercent;
});
